import * as React from 'react'

import ListItem             from '@material-ui/core/ListItem'
import ListItemIcon         from '@material-ui/core/ListItemIcon'
import ListItemText         from '@material-ui/core/ListItemText'
import SettingsIcon         from '@material-ui/icons/Settings'
import { FormattedMessage } from 'react-intl'

import testingHooks from '../../testing-hooks'
import { Settings } from '../organisms'

export default () => (
  <Settings>
    {({ open }) => (
      <ListItem
        divider
        data-test-id={testingHooks.drawerMenuListItem}
        button
        onClick={open}
      >
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText
          data-test-id={testingHooks.drawerMenuListItemText}
          inset
          primary={(
            <FormattedMessage
              id={'tooltip.settings'}
              defaultMessage={'Settings'}
            />
          )}
        />
      </ListItem>
    )}
  </Settings>
)



// WEBPACK FOOTER //
// ./src/components/molecules/SettingsTool.tsx